import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { statsKeys } from '../queries/keys';
import { statsPaths } from '../queries/paths';

// Estadísticas por entidad (admin-stats.md). Read puro, `kpis:read`. Filtros:
// from/to (donante: fecha OPU; semen/lab: fecha clivage) + client_id/farm_id (semen/lab).
function clean(filters = {}) {
    const out = {};
    for (const k of ['from', 'to', 'client_id', 'farm_id']) {
        const v = filters[k];
        if (v !== '' && v != null) out[k] = v;
    }
    return out;
}

export function useAnimalStats(id, filters = {}) {
    const params = clean(filters);
    return useQuery({
        queryKey: statsKeys.animal(id, params),
        queryFn:  ({ signal }) => api.get(statsPaths.animal(id), { params, signal }).then(r => r.data),
        enabled:  !!id,
        placeholderData: (prev) => prev,
    });
}

export function useSemenStats(id, filters = {}) {
    const params = clean(filters);
    return useQuery({
        queryKey: statsKeys.semen(id, params),
        queryFn:  ({ signal }) => api.get(statsPaths.semen(id), { params, signal }).then(r => r.data),
        enabled:  !!id,
        placeholderData: (prev) => prev,
    });
}

export function useLabStats(id, filters = {}) {
    const params = clean(filters);
    return useQuery({
        queryKey: statsKeys.lab(id, params),
        queryFn:  ({ signal }) => api.get(statsPaths.lab(id), { params, signal }).then(r => r.data),
        enabled:  !!id,
        placeholderData: (prev) => prev,
    });
}

// Stats combinadas por cliente (0045/0049): donors_kpi (donadoras co-poseídas = cowhousing)
// + recipients_kpi (receptoras/tag de parcería) + report. Filtros from/to (por-bloque).
export function useClientStats(id, filters = {}) {
    const params = clean(filters);
    return useQuery({
        queryKey: statsKeys.client(id, params),
        queryFn:  ({ signal }) => api.get(statsPaths.client(id), { params, signal }).then(r => r.data),
        enabled:  !!id,
        placeholderData: (prev) => prev,
    });
}
